import { render } from "./Select2.vue?vue&type=template&id=0e029eec"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"
script.render = render

export default script